import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { listScripts } from '../clients/grpc';
import { ListScriptsRequest, Script } from '../generated/v1alpha1/script_processing_pb';
import { AuthContext } from '../contexts/AuthContext';

const ScriptList: React.FC = () => {
  const [scripts, setScripts] = useState<Script[]>([]);
  const [error, setError] = useState<string | null>(null);
  const { accessToken } = useContext(AuthContext);

  useEffect(() => {
    const fetchScripts = async () => {
      try {
        const request = new ListScriptsRequest();
        const response = await listScripts(request);
        setScripts(response.getScriptsList());
      } catch (err) {
        setError((err as Error).message);
      }
    };
    console.log('Fetching processed scripts')
    fetchScripts();
  }, [accessToken]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  // to add columns, add <th>Col name</th> and below <td> script.getX </td>
  return (
  <div className="script-details-container">
    <div>
      <h1>Processed Scripts</h1>
      Click any of the below scripts to view the full coverage.
      <table>
        <thead>
          <tr>
            <th>Script Name</th>
          </tr>
        </thead>
        <tbody>
          {scripts.map((script) => (
            <tr key={script.getName()}>
              <td>
                <Link to={`/scripts/${script.getName()}`}>{script.getName()}</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
  );
};

export default ScriptList;
